import React,{useRef, useEffect} from "react";
import { useSelector, shallowEqual, useDispatch } from "react-redux";
import Async from "react-code-splitting";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { handleMobileOrDesktop } from "../redux/actions/mainActions";
import { handleMenuAction } from "../redux/actions/menuAction";
import { isLoading } from "../redux/actions/mainActions";
import withStyles from "@material-ui/core/styles/withStyles";
import menuStyle from "../assets/jss/material-dashboard-react/layouts/menuStyle.jsx";
import AppBar from '@material-ui/core/AppBar';
import InputBase from '@material-ui/core/InputBase';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import { fade, makeStyles } from '@material-ui/core/styles';
import AccountCircle from '@material-ui/icons/AccountCircle';
import MenuItem from '@material-ui/core/MenuItem';
import Menu from '@material-ui/core/Menu';
import AvettiLogo from "../assets/img/AvettiLogo.png";
import SearchIcon from '@material-ui/icons/Search';
import MoreIcon from '@material-ui/icons/MoreVert';
import MenuIcon from '@material-ui/icons/Menu';
import Button from '@material-ui/core/Button';
import Badge from '@material-ui/core/Badge';
import MailIcon from '@material-ui/icons/Mail';
import NotificationsIcon from '@material-ui/icons/Notifications';

import Profie from "../header/Profile.jsx";


import b2bmenu from "../data/b2cmenu.json"
//import Abcart from "../components/AC-StaticPages/b2c/B2C-List/Orders/abandoncart";

const Main = (props) => <Async componentProps={props} load={import("../content/Main.jsx")} />;
const NotFound = (props) => <Async componentProps={props} load={import("../content/NotFound.jsx")} />;
const Breadcrumb = (props) => <Async componentProps={props} load={import("../components/AC-StaticPages/Breadcrumb/Breadcrumb.js")} />;
const B2C = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2c/b2c")} />;
const Docs = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/docs/docs")} />;
const Login = (props) => < Async componentProps={props} load={import("../components/AC-LoginBox/Login.jsx")} />;
const MarketPlacePage = (props) => <Async componentProps={props} load={import("../content/MarketPlacePage")}/>
//orders
const Orders = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2c/B2C-List/Orders/orders")} />;
const ManageOrders = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2c/B2C-List/Orders/manageorders")} />;
const Customermessage = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2c/B2C-List/Orders/customermessage")} />;
const Abcart = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2c/B2C-List/Orders/abandoncart")} />;
const ManageRefund = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2c/B2C-List/Orders/managerefund")} />;
const Reports = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2c/B2C-List/Orders/reports")} />;

const Emailstate = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2c/B2C-List/Orders/emailstate")} />;
//catalog
const Catalog = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2c/B2C-List/Catalog/catalog")} />;
const Categories = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2c/B2C-List/Catalog/categories")} />;
const Downloadableitems = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2c/B2C-List/Catalog/downloadableitems")} />;
const Frequentlyboughtitems = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2c/B2C-List/Catalog/frequentlyboughtitems")} />;
const Inventory = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2c/B2C-List/Catalog/inventory")} />;
const Itemreviews = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2c/B2C-List/Catalog/itemreviews")} />;
const Itemsize = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2c/B2C-List/Catalog/itemsize")} />;
const Managefacets = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2c/B2C-List/Catalog/managefacets")} />;
const Managefaqs = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2c/B2C-List/Catalog/managefaqs")} />;
const Managegalleries = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2c/B2C-List/Catalog/managegalleries")} />;
const Manageproductpurchase = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2c/B2C-List/Catalog/manageproductpurchase")} />;
const Manageproduct = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2c/B2C-List/Catalog/manageproduct")} />;
const Multilingualcontent = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2c/B2C-List/Catalog/multilingualcontent")} />;
const Personalizedelements = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2c/B2C-List/Catalog/personalizedelements")} />;
const Prices = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2c/B2C-List/Catalog/prices")} />;
const Publishtoshop = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2c/B2C-List/Catalog/publishtoshop")} />;
const Validatecatalogdata = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2c/B2C-List/Catalog/validatecatalogdata")} />;
const Variations = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2c/B2C-List/Catalog/variations")} />;
const Viewstore = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2c/B2C-List/Catalog/viewstore")} />;


//Videotutorial orders
const VideoTutorialComponent = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/Videos/Video-list/Orders/VideoTutorialComponent.js")} />;
const VideoTutorials = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/Videos/Video-list/Orders/VideoTutorials.js")} />;

//ManageMedia
const Media = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2c/B2C-List/Media/media")} />;
const ManageMedia = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2c/B2C-List/Media/managemedia")} />;

//Templates
const Templates = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2c/B2C-List/Templates/templates")} />;
const Catalogpersonalization = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2c/B2C-List/Templates/catalogpersonalization")} />;
const CMISexportimport = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2c/B2C-List/Templates/cMISexportimport")} />;
const ResetcDTOcache = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2c/B2C-List/Templates/resetcDTOcache")} />;
const Templatelog = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2c/B2C-List/Templates/templatelog")} />;
const Templateskins = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2c/B2C-List/Templates/templateskins")} />;

//Marketing
const Marketing = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2c/B2C-List/Marketing/marketing")} />;
const ABsplittests = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2c/B2C-List/Marketing/absplittests")} />;
const Bundles = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2c/B2C-List/Marketing/bundles")} />;
const Coupons = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2c/B2C-List/Marketing/coupons")} />;
const Promotions = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2c/B2C-List/Marketing/promotions")} />;
const CustomerSegments = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2c/B2C-List/Marketing/customersegments")} />;
const CustomerSegmentPrices = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2c/B2C-List/Marketing/customersegmentprices")} />;
const CustomerSegmentads = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2c/B2C-List/Marketing/customersegmentads")} />;
const SalesAreaGeolocation = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2c/B2C-List/Marketing/salesareageolocation")} />;
const UpsellCrosssell = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2c/B2C-List/Marketing/upsellcrosssell")} />;
const Addons = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2c/B2C-List/Marketing/addons")} />;
const BasketAdditions = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2c/B2C-List/Marketing/basketadditions")} />;
const EmptyLandingPages = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2c/B2C-List/Marketing/emptylandingpages")} />;
const CustomerDiscounts = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2c/B2C-List/Marketing/customerdiscounts")} />;
const ViralPromotions = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2c/B2C-List/Marketing/viralpromotions")} />;
const GiftCards = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2c/B2C-List/Marketing/giftcards")} />;
const GiftCertificates = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2c/B2C-List/Marketing/giftcertificates")} />;

//Settings
const Settings = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2c/B2C-List/Settings/settings")} />;
const BasketPreferences = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2c/B2C-List/Settings/basketpreferences")} />;
const ImageScaling = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2c/B2C-List/Settings/imagescaling")} />;
const ItemProperties = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2c/B2C-List/Settings/itemproperties")} />;
const Languages = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2c/B2C-List/Settings/languages")} />;
const OrderPreferences = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2c/B2C-List/Settings/Orderpreferences")} />;
const PageParameters = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2c/B2C-List/Settings/pageparameters")} />;
const PaymentGateways = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2c/B2C-List/Settings/paymentgateways")} />;
const ProductSegments = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2c/B2C-List/Settings/productsegments")} />;
const RetailLocation = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2c/B2C-List/Settings/retaillocation")} />;
const SearchDictionary = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2c/B2C-List/Settings/searchdictionary")} />;
const ShippingCountries = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2c/B2C-List/Settings/shippingcountries")} />;
const ShippingExceptions = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2c/B2C-List/Settings/shippingexceptions")} />;
const ShippingPackages = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2c/B2C-List/Settings/shippingpackages")} />;
const ShippingRates = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2c/B2C-List/Settings/shippingrates")} />;
const Sitemaps = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2c/B2C-List/Settings/sitemaps")} />;
const StoreCurrencies = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2c/B2C-List/Settings/storecurrencies")} />;
const StoreHours = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2c/B2C-List/Settings/storehours")} />;
const StorePreferences = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2c/B2C-List/Settings/storepreferences")} />;
const StoreProperties = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2c/B2C-List/Settings/storeproperties")} />;
const TaxRates = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2c/B2C-List/Settings/taxrates")} />;

//Advanced
const Advanced = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2c/B2C-List/Advanced/advanced")} />;
const CDTOEditor = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2c/B2C-List/Advanced/cdtoeditor")} />;
const ChangePassword = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2c/B2C-List/Advanced/changepassword")} />;
const PasswordSecurityRules = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2c/B2C-List/Advanced/passwordsecurityrules")} />;
const ReportsConfiguration = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2c/B2C-List/Advanced/reportsconfiguration")} />;
const ShopperPwdSecurity = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2c/B2C-List/Advanced/shopperpwdsecurity")} />;
const SiteAdminPreferences = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2c/B2C-List/Advanced/siteadminpreferences")} />;
const SolrCategories = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2c/B2C-List/Advanced/solrcategories")} />;
const SolrItems = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2c/B2C-List/Advanced/solritems")} />;

//People 
const People = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2c/B2C-List/People/people")} />;
const Allowances = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2c/B2C-List/People/allowances")} />;
const CustomerActivity = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2c/B2C-List/People/customeractivity")} />;
const CustomerProperties = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2c/B2C-List/People/customerproperties")} />;
const Customers = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2c/B2C-List/People/customers")} />;
const MemberTypes = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2c/B2C-List/People/membertypes")} />;

//Auditlogs
const AuditLogs = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2c/B2C-List/AuditLogs/auditlogs")} />;
const AuditLogsViews = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2c/B2C-List/AuditLogs/auditlogviews")} />;

//Advanced-Marketplace
const Advancedmp = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2b/B2B-Staticpages/Advanced/advancedmp")} />;
const CDTOEditormp = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2b/B2B-Staticpages/Advanced/cdtoeditormp")} />;
const ChangePasswordmp = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2b/B2B-Staticpages/Advanced/changepasswordmp")} />;
const PasswordSecurityRulesmp = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2b/B2B-Staticpages/Advanced/passwordsecurityrulesmp")} />;
const ReportsConfigurationmp = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2b/B2B-Staticpages/Advanced/reportsconfigurationmp")} />;
const ShopperPwdSecuritymp = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2b/B2B-Staticpages/Advanced/shopperpwdsecuritymp")} />;
const SiteAdminPreferencesmp = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2b/B2B-Staticpages/Advanced/siteadminpreferencesmp")} />;
const SolrCategoriesmp = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2b/B2B-Staticpages/Advanced/solrcategoriesmp")} />;
const SolrItemsmp = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2b/B2B-Staticpages/Advanced/solritemsmp")} />;
const SupplierSubscriptionmp = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2b/B2B-Staticpages/Advanced/suppliersubscriptionmp")} />;
const SupplierSubscriptionSettingsmp = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2b/B2B-Staticpages/Advanced/suppliersubscriptionsettingsmp")} />;

//Catalog-Marketplace
const Catalogmp = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2b/B2B-Staticpages/Catalog/catalogmp")} />;
const Categoriesmp = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2b/B2B-Staticpages/Catalog/categoriesmp")} />;
const Inventorymp = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2b/B2B-Staticpages/Catalog/inventorymp")} />;
const ItemReviewsmp = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2b/B2B-Staticpages/Catalog/itemreviewsmp")} />;
const ItemSizemp = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2b/B2B-Staticpages/Catalog/itemsizemp")} />;
const ManageFacetsmp = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2b/B2B-Staticpages/Catalog/managefacetsmp")} />;
const Pricesmp = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2b/B2B-Staticpages/Catalog/pricesmp")} />;
const ItemOptionsmp = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2b/B2B-Staticpages/Catalog/itemoptionsmp")} />;
const ItemStatusSettingsmp = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2b/B2B-Staticpages/Catalog/itemstatussettingsmp")} />;

//Marketing-MarketPlace
const Marketingmp = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2b/B2B-Staticpages/Marketing/marketingmp")} />;
//const Blogsmp = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2b/B2B-Staticpages/Marketing/blogsmp")} />;
const Bundlesmp = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2b/B2B-Staticpages/Marketing/bundlesmp")} />;
const Couponsmp = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2b/B2B-Staticpages/Marketing/couponsmp")} />;
const CustomerSegmentsmp = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2b/B2B-Staticpages/Marketing/customersegmentsmp")} />;
const CustomerSegmentPricesmp = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2b/B2B-Staticpages/Marketing/customersegmentpricemp")} />;
const CustomerSegmentadsmp = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2b/B2B-Staticpages/Marketing/customersegmentadsmp")} />;
const SalesAreaGeolocationmp = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2b/B2B-Staticpages/Marketing/salesareageolocationmp")} />;
const UpsellCrosssellmp = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2b/B2B-Staticpages/Marketing/upsellcrosssellmp")} />;
const CustomerDiscountsmp = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2b/B2B-Staticpages/Marketing/customerdiscountsmp")} />;
const ViralPromotionsmp = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2b/B2B-Staticpages/Marketing/viralpromotionsmp")} />;
const GiftCardsmp = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2b/B2B-Staticpages/Marketing/giftcardsmp")} />;
const GiftCertificatesmp = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2b/B2B-Staticpages/Marketing/giftcertificatesmp")} />;
const CustomerRetargetingmp = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2b/B2B-Staticpages/Marketing/customerretargetingmp")} />;
const ShippingExceptionsmp = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2b/B2B-Staticpages/Marketing/shippingexceptionsmp")} />;
const MarketingSegmentsmp = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2b/B2B-Staticpages/Marketing/marketingsegmentsmp")} />;

//MarketPlace 
const MarketPlacemp = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2b/B2B-Staticpages/Marketplace/marketplacemp")} />;
const ApproveProductsmp = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2b/B2B-Staticpages/Marketplace/approveproductsmp")} />;
const CategoryProfitMarginmp = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2b/B2B-Staticpages/Marketplace/categoryprofitmarginmp")} />;
const Commissionsmp = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2b/B2B-Staticpages/Marketplace/commissionsmp")} />;
const MarketPlaceCategoriesmp = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2b/B2B-Staticpages/Marketplace/marketplacecategoriesmp")} />;
const MarketplacePaymentsmp = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2b/B2B-Staticpages/Marketplace/marketplacepaymentsmp")} />;
const MarketPlacecSuppliersmp = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2b/B2B-Staticpages/Marketplace/marketplacesuppliersmp")} />;
const MasterCatalogProductsmp = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2b/B2B-Staticpages/Marketplace/mastercatalogproductsmp")} />;
const Notificationsmp = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2b/B2B-Staticpages/Marketplace/notificationsmp")} />;

//ManageMedia-MarketPlace
const Mediamp = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2b/B2B-Staticpages/Media/mediamp")} />;
const ManageMediamp = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2b/B2B-Staticpages/Media/managemediamp")} />;

//orders-MarketPlace
const Ordersmp = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2b/B2B-Staticpages/Orders/ordersmp")} />;
const ManageOrdersmp = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2b/B2B-Staticpages/Orders/manageordersmp")} />;
//const Customermessagemp = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2b/B2B-Staticpages/Orders/customermessage")} />;
const ManageRefundsmp = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2b/B2B-Staticpages/Orders/managerefundsmp")} />;
//const EmailSettingsmp = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2b/B2B-Staticpages/Orders/emailsettingsmp")} />;
//const EmailStatemp = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2b/B2B-Staticpages/Orders/emailstatemp")} />;
//const ManageOrderApprovalsGroupmp = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2b/B2B-Staticpages/Orders/manageorderapprovalsgroupmp")} />;
//const SellerRatingsmp = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2b/B2B-Staticpages/Orders/sellerratingsmp")} />;
//const SmsSettingsmp = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2b/B2B-Staticpages/Orders/smssettingsmp")} />;
//const SmsStatemp = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2b/B2B-Staticpages/Orders/smsstatemp")} />;

//People-MarketPlace
const Peoplemp = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2b/B2B-Staticpages/People/peoplemp")} />;
const CustomerPropertiesmp = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2b/B2B-Staticpages/People/customerpropertiesmp")} />;
const Customersmp = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2b/B2B-Staticpages/People/customersmp")} />;
//const SSOrulesmp = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2b/B2B-Staticpages/People/ssorulesmp")} />;

//Settings-MarketPlace
const Settingsmp = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2b/B2B-Staticpages/Settings/settingsmp")} />;
const BasketPreferencesmp = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2b/B2B-Staticpages/Settings/basketpreferencesmp")} />;
const ImageScalingmp = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2b/B2B-Staticpages/Settings/imagescalingmp")} />;
const ItemPropertiesmp = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2b/B2B-Staticpages/Settings/itempropertiesmp")} />;
const OrderPreferencesmp = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2b/B2B-Staticpages/Settings/Orderpreferencesmp")} />;
const PaymentGatewaysmp = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2b/B2B-Staticpages/Settings/paymentgatewaysmp")} />;
const RetailLocationmp = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2b/B2B-Staticpages/Settings/retaillocationmp")} />;
const ShippingCountriesmp = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2b/B2B-Staticpages/Settings/shippingcountriesmp")} />;
//const ShippingRatesmp = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2b/B2B-Staticpages/Settings/shippingratesmp")} />;
//const Sitemapsmp = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2b/B2B-Staticpages/Settings/sitemapsmp")} />;
const StoreCurrenciesmp = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2b/B2B-Staticpages/Settings/storecurrenciesmp")} />;
const StorePreferencesmp = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2b/B2B-Staticpages/Settings/storepreferencesmp")} />;
//const StorePropertiesmp = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2b/B2B-Staticpages/Settings/storepropertiesmp")} />;
const TaxRatesmp = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2b/B2B-Staticpages/Settings/taxratesmp")} />;

//Templates-MarketPlace
const Templatesmp = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2b/B2B-Staticpages/Templates/templatesmp")} />;
const CatalogPersonalizationmp = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2b/B2B-Staticpages/Templates/catalogpersonalizationmp")} />;
const ResetCDTOcachemp = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2b/B2B-Staticpages/Templates/resetCDTOcachemp")} />;
//const Templateskinsmp = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2b/B2B-Staticpages/Templates/templateskinsmp")} />;
const ManageTemplatesmp = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2b/B2B-Staticpages/Templates/managetemplatesmp")} />;

//Catalog-Supplier
const Catalogsp = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2s/b2s-staticpages/Catalog/catalogsp")} />;
const Productssp = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2s/b2s-staticpages/Catalog/productsp")} />;
const Inventorysp = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2s/b2s-staticpages/Catalog/inventorysp")} />;
const ItemPropertiessp = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2s/b2s-staticpages/Catalog/itempropertiessp")} />;

//Dashboard-suppliers
const Dashboardsp = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2s/b2s-staticpages/Dashboard/dashboardsp")} />;

//Marketplace-supplier
const Marketplacesp = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2s/b2s-staticpages/Marketplace/marketplacesp")} />;
const Notificationssp = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2s/b2s-staticpages/Marketplace/notificationssp")} />;
const MarketplacePaymentssp = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2s/b2s-staticpages/Marketplace/marketplacepaymentssp")} />;
const ApproveProductssp = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2s/b2s-staticpages/Marketplace/approveproductssp")} />;

//Media-supplier
const Mediasp = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2s/b2s-staticpages/Media/mediasp")} />;
const Managemediasp = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2s/b2s-staticpages/Media/managemediasp")} />;

//Orders-supplier
const Orderssp = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2s/b2s-staticpages/Orders/orderssp")} />;
const Manageorderssp = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2s/b2s-staticpages/Orders/manageorderssp")} />;
const Managerefundssp = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2s/b2s-staticpages/Orders/managerefundssp")} />;
const Reportssp = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2s/b2s-staticpages/Orders/reportssp")} />;
const Customermessagessp = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/b2s/b2s-staticpages/Orders/customermessagessp")} />;

//Advances-MCW
const Advancedmcw = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/mcw/mcwstaticpages/Advanced/advancedmcw")} />;
const Changepasswordmcw = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/mcw/mcwstaticpages/Advanced/changepasswordmcw")} />;

//Media-MCW
const Mediamcw = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/mcw/mcwstaticpages/ManageMedia/mediamcw")} />;
const Managemediamcw = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/mcw/mcwstaticpages/ManageMedia/managemediamcw")} />;

//Catalog-MCW
const Catalogmcw = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/mcw/mcwstaticpages/Catalog/catalogmcw")} />;
const Categoriesmcw = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/mcw/mcwstaticpages/Catalog/categoriesmcw")} />;
const Inventorymcw = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/mcw/mcwstaticpages/Catalog/inventorymcw")} />;
const Itemreviewsmcw = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/mcw/mcwstaticpages/Catalog/itemreviewsmcw")} />;
const Itemsizemcw = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/mcw/mcwstaticpages/Catalog/itemsizemcw")} />;
const Pricesmcw = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/mcw/mcwstaticpages/Catalog/itemstatussettingsmcw")} />;
const Variationsmcw = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/mcw/mcwstaticpages/Catalog/pricesmcw")} />;
const Itemstatussettingsmcw = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/mcw/mcwstaticpages/Catalog/variationsmcw")} />;

//MarketPlace-MCW
const Marketplacemcw = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/mcw/mcwstaticpages/MarketPlace/marketplacemcw")} />;
const Approveproductsmcw = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/mcw/mcwstaticpages/MarketPlace/approveproductsmcw")} />;
const Marketplacecsuppliersmcw = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/mcw/mcwstaticpages/MarketPlace/marketplacecsuppliersmcw")} />;
const Notificationsmcw = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/mcw/mcwstaticpages/MarketPlace/notificationsmcw")} />;

//Settings-MCW
const Settingsmcw = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/mcw/mcwstaticpages/Settings/settingsmcw")} />;
const Itempropertiesmcw = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/mcw/mcwstaticpages/Settings/itempropertiesmcw")} />;
const Shippingcountriesmcw = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/mcw/mcwstaticpages/Settings/shippingcountriesmcw")} />;
const Storecurrenciesmcw = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/mcw/mcwstaticpages/Settings/storecurrenciesmcw")} />;
const Storepreferencesmcw = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/mcw/mcwstaticpages/Settings/storepreferencesmcw")} />;
const Storepropertiesmcw = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/mcw/mcwstaticpages/Settings/storepropertiesmcw")} />;

//OrderMcw
const Ordersmcw = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/mcw/mcwstaticpages/Orders/ordersmcw")} />;
const Customermessagesmcw = (props) => < Async componentProps={props} load={import("../components/AC-StaticPages/mcw/mcwstaticpages/Orders/customermessagesmcw")} />;

const News = () => < Async load={import("../components/AC-StaticPages/News/News")} />;
const Quotes = () => < Async load={import("../components/AC-StaticPages/Quotes/Quotes")} />;
const MenuCore = (props) => <Async componentProps={props} load={import("./MenuCore.jsx")} />;
const Footer = (props) => <Async componentProps={props} load={import("../components/AC-Footer/Footer")} />;

const Loading = () => (
  <Async load={import("../components/AC-Loading/Loading.jsx")} />
);

const useStyles = makeStyles((theme) => ({
  grow: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    display: 'none',
    [theme.breakpoints.up('sm')]: {
      display: 'block',
    },
  },
  search: {
    position: 'relative',
    borderRadius: theme.shape.borderRadius,

    marginRight: theme.spacing(2),
    marginLeft: 0,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      marginLeft: theme.spacing(3),
      width: 'auto',
    },
  },

}));

function Menus(props) {
  const dispatch = useDispatch();
  const classes = useStyles();
  const [auth, setAuth] = React.useState(true);

  const handleChange = (event) => {
    setAuth(event.target.checked);
  };

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const loading = useSelector(
    state => state.mainReducer.loading,
    shallowEqual
  );

  const [anchorEl, setAnchorEl] = React.useState(null);
  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = React.useState(null);

  const isMenuOpen = Boolean(anchorEl);
  const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);

  const handleProfileMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMobileMenuClose = () => {
    setMobileMoreAnchorEl(null);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    handleMobileMenuClose();
  };

  const handleMobileMenuOpen = (event) => {
    setMobileMoreAnchorEl(event.currentTarget);
  };

  const menuId = 'primary-search-account-menu';
  const renderMenu = (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      id={menuId}
      keepMounted
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      open={isMenuOpen}
      onClose={handleMenuClose}
    >
      <MenuItem onClick={handleMenuClose}>Profile</MenuItem>
      <MenuItem onClick={handleMenuClose}>My account</MenuItem>
    </Menu>
  );

  const mobileMenuId = 'primary-search-account-menu-mobile';
  const renderMobileMenu = (
    <Menu
      anchorEl={mobileMoreAnchorEl}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      id={mobileMenuId}
      keepMounted
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      open={isMobileMenuOpen}
      onClose={handleMobileMenuClose}
    >
      <MenuItem>
        <IconButton aria-label="show 4 new mails" color="inherit">
          <Badge badgeContent={4} color="secondary">
            <MailIcon />
          </Badge>
        </IconButton>
        <p>Messages</p>
      </MenuItem>
      <MenuItem>
        <IconButton aria-label="show 11 new notifications" color="inherit">
          <Badge badgeContent={11} color="secondary">
            <NotificationsIcon />
          </Badge>
        </IconButton>
        <p>Notifications</p>
      </MenuItem>
      <MenuItem onClick={handleProfileMenuOpen}>
        <IconButton
          aria-label="account of current user"
          aria-controls="primary-search-account-menu"
          aria-haspopup="true"
          color="inherit"
        >
          <AccountCircle />
        </IconButton>
        <p>Profile</p>
      </MenuItem>
    </Menu>
  );

  const [width, setWidth] = React.useState(window.innerWidth);
  React.useEffect(() => {
    const handleResize = () => {
      setWidth(window.innerWidth);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };

  }, []);
  let isMobile;
  const mobileSize = 768;
  React.useEffect(() => {
    if (width > mobileSize) {
      isMobile = false;
    } else {
      isMobile = true;
    }
    dispatch(handleMobileOrDesktop(isMobile));
    dispatch(handleMenuAction(b2bmenu));
    dispatch(isLoading(false));
  }, [width]);

  const isMobileState = useSelector(
    state => state.mainReducer.isMobile,
    shallowEqual
  );
  
  console.log("menus", props)

  const handleWhatComponentToShowHere = () => {
    if (props.component == "b2c") {
      return <B2C  {...props} />;
    } else if (props.component == "b2b") {
      return <News {...props} />;
    } else if (props.component == "punchout") {
      return <Quotes {...props} />;
    } else if (props.component == "docs") {
      return <News  {...props} />;
    } else if (props.component == "orders") {
      return <Orders  {...props} />;
    } else if (props.component == "catalog") {
      return <Catalog  {...props} />;
    } else if (props.component == "manageorders") {
      return <ManageOrders  {...props} />;
    } else if (props.component == "customermessages") {
      return <Customermessage  {...props} />;
    } else if (props.component == "emailstate") {
      return <Emailstate {...props} />;
    } else if (props.component == "abandoncart") {
      return <Abcart {...props} />;
    } else if (props.component == "managerefunds") {
      return <ManageRefund  {...props} />;
    }
    else if (props.component == "login") {
      return <Login  {...props} />;
    }
    else if (props.component == "reports") {
      return <Reports  {...props} />;
    }
    else if (props.component == "VideoTutorials") {
      return <VideoTutorials {...props} />;
    }
    else if (props.component == "categories") {
      return <Categories {...props} />;
    }
    else if (props.component == "downloadableitems") {
      return <Downloadableitems {...props} />;
    }
    // else if (props.component == "frequentlyboughtitems") {
    //   return <Frequentlyboughtitems {...props} />;
    // }
     else if (props.component == "inventory") {
       return <Inventory {...props} />;
     }
    else if (props.component == "itemreviews") {
      return <Itemreviews {...props} />;
    }
    else if (props.component == "itemsize") {
      return <Itemsize  {...props} />;
    }
    else if (props.component == "managefacets") {
      return <Managefacets  {...props} />;
    }
    else if (props.component == "managefaqs") {
      return <Managefaqs {...props} />;
    }
     else if (props.component == "managegalleries") {
       return <Managegalleries {...props} />;
     }
    // else if (props.component == "manageproductpurchase") {
    //   return <Manageproductpurchase {...props} />;
    // }
     else if (props.component == "manageproduct") {
      return <Manageproduct {...props} />;
     }
     else if (props.component == "multilingualcontent") {
       return <Multilingualcontent {...props} />;
     }
    // else if (props.component == "personalizedelements") {
    //   return <Personalizedelements {...props} />;
    // }
     else if (props.component == "prices") {
       return <Prices {...props} />;
     }
    // else if (props.component == "publishtoshop") {
    //   return <Publishtoshop {...props} />;
    // }
     else if (props.component == "validatecatalogdata") {
       return <Validatecatalogdata {...props} />;
     }
     else if (props.component == "variations") {
       return <Variations {...props} />;
     }
    else if (props.component == "viewstore") {
      return <Viewstore {...props} />;
    }
    else if (props.component == "videoTutorialComponent") {
      return <VideoTutorialComponent {...props} />;
    }
    else if (props.component == "VideoTutorials") {
      return <VideoTutorials {...props} />;
    }
    else if (props.component == "media") {
      return <Media {...props} />;
    }
    else if (props.component == "managemedia") {
      return <ManageMedia {...props} />;
    }
    else if (props.component == "templates") {
      return <Templates {...props} />;
    }
    else if (props.component == "catalogpersonalization") {
      return <Catalogpersonalization {...props} />;
    }
   // else if (props.component == "cMISexportimport") {
     // return <CMISexportimport {...props} />;
    //}
    else if (props.component == "resetcDTOcache") {
      return <ResetcDTOcache {...props} />;
    }
    //else if (props.component == "templatelog") {
    //  return <Templatelog {...props} />;
    //}
    else if (props.component == "templateskins") {
      return <Templateskins {...props} />;
    }
    else if (props.component == "marketing") {
      return <Marketing {...props} />;
    }
    else if (props.component == "absplittests") {
      return <ABsplittests {...props} />;
    }
    else if (props.component == "bundles") {
      return <Bundles {...props} />;
    }
    else if (props.component == "coupons") {
      return <Coupons {...props} />;
    }
    else if (props.component == "promotions") {
      return <Promotions {...props} />;
    }
    else if (props.component == "customersegments") {
      return <CustomerSegments {...props} />;
    }
    else if (props.component == "customersegmentprices") {
      return <CustomerSegmentPrices {...props} />;
    }
    else if (props.component == "customersegmentads") {
      return <CustomerSegmentads {...props} />;
    }
    else if (props.component == "salesareageolocation") {
      return <SalesAreaGeolocation {...props} />;
    }
    else if (props.component == "upsellcrosssell") {
      return <UpsellCrosssell {...props} />;
    }
    else if (props.component == "addons") {
      return <Addons {...props} />;
    }
    else if (props.component == "basketadditions") {
      return <BasketAdditions {...props} />;
    }
  //  else if (props.component == "emptylandingpages") {
    //  return <EmptyLandingPages {...props} />;
  //  }
    else if (props.component == "customerdiscounts") {
      return <CustomerDiscounts {...props} />;
    }
    else if (props.component == "viralpromotions") {
      return <ViralPromotions {...props} />;
    }
    else if (props.component == "giftcards") {
      return <GiftCards {...props} />;
    }
    else if (props.component == "giftcertificates") {
      return <GiftCertificates {...props} />;
    }
    else if (props.component == "settings") {
      return <Settings {...props} />;
    }
    else if (props.component == "basketpreferences") {
      return <BasketPreferences {...props} />;
    }
    else if (props.component == "imagescaling") {
      return <ImageScaling {...props} />;
    }
    else if (props.component == "itemproperties") {
      return <ItemProperties {...props} />;
    }
    else if (props.component == "languages") {
      return <Languages {...props} />;
    }
    else if (props.component == "Orderpreferences") {
      return <OrderPreferences {...props} />;
    }
    else if (props.component == "pageparameters") {
      return <PageParameters {...props} />;
    }
    else if (props.component == "paymentgateways") {
      return <PaymentGateways {...props} />;
    }
    else if (props.component == "productsegments") {
      return <ProductSegments {...props} />;
    }
    else if (props.component == "retaillocation") {
      return <RetailLocation {...props} />;
    }
    else if (props.component == "searchdictionary") {
      return <SearchDictionary {...props} />;
    }
    else if (props.component == "shippingcountries") {
      return <ShippingCountries {...props} />;
    }
    else if (props.component == "shippingexceptions") {
      return <ShippingExceptions {...props} />;
    }
    else if (props.component == "shippingpackages") {
      return <ShippingPackages {...props} />;
    }
    else if (props.component == "shippingrates") {
      return <ShippingRates {...props} />;
    }
    else if (props.component == "sitemaps") {
      return <Sitemaps {...props} />;
    }
    else if (props.component == "storecurrencies") {
      return <StoreCurrencies {...props} />;
    }
    else if (props.component == "storehours") {
      return <StoreHours {...props} />;
    }
    else if (props.component == "storepreferences") {
      return <StorePreferences {...props} />;
    }
    else if (props.component == "storeproperties") {
      return <StoreProperties {...props} />;
    }
    else if (props.component == "taxrates") {
      return <TaxRates {...props} />;
    }
    else if (props.component == "advanced") {
      return <Advanced {...props} />;
    }
    else if (props.component == "cdtoeditor") {
      return <CDTOEditor {...props} />;
    }
    else if (props.component == "changepassword") {
      return <ChangePassword {...props} />;
    }
    else if (props.component == "passwordsecurityrules") {
      return <PasswordSecurityRules {...props} />;
    }
    else if (props.component == "reportsconfiguration") {
      return <ReportsConfiguration {...props} />;
    }
    else if (props.component == "shopperpwdsecurity") {
      return <ShopperPwdSecurity {...props} />;
    }
    else if (props.component == "siteadminpreferences") {
      return <SiteAdminPreferences {...props} />;
    }
    else if (props.component == "solrcategories") {
      return <SolrCategories {...props} />;
    }
    else if (props.component == "solritems") {
      return <SolrItems {...props} />;
    }
    else if (props.component == "people") {
      return <People {...props} />;
    }
    else if (props.component == "allowances") {
      return <Allowances {...props} />;
    }
    else if (props.component == "customeractivity") {
      return <CustomerActivity {...props} />;
    }
    else if (props.component == "customerproperties") {
      return <CustomerProperties {...props} />;
    }
    else if (props.component == "customers") {
      return <Customers {...props} />;
    }
    else if (props.component == "membertypes") {
      return <MemberTypes {...props} />;
    }
    else if (props.component == "auditlogs") {
      return <AuditLogs {...props} />;
    }
    else if (props.component == "auditlogviews") {
      return <AuditLogsViews {...props} />;
    }
    else if (props.component == "auditlogviews") {
      return <AuditLogsViews {...props} />;
    }
    else if (props.component == "advancedmp") {
      return <Advancedmp {...props} />;
    }
    else if (props.component == "cdtoeditormp") {
      return <CDTOEditormp {...props} />;
    }
    else if (props.component == "changepasswordmp") {
      return <ChangePasswordmp {...props} />;
    }
    else if (props.component == "passwordsecurityrulesmp") {
      return <PasswordSecurityRulesmp {...props} />;
    }
    else if (props.component == "reportsconfigurationmp") {
      return <ReportsConfigurationmp {...props} />;
    }
    else if (props.component == "shopperpwdsecuritymp") {
      return <ShopperPwdSecuritymp {...props} />;
    }
    else if (props.component == "siteadminpreferencesmp") {
      return <SiteAdminPreferencesmp {...props} />;
    }
    else if (props.component == "solrcategoriesmp") {
      return <SolrCategoriesmp {...props} />;
    }
    else if (props.component == "solritemsmp") {
      return <SolrItemsmp {...props} />;
    }
    else if (props.component == "suppliersubscriptionmp") {
      return <SupplierSubscriptionmp {...props} />;
    }
    else if (props.component == "suppliersubscriptionsettingsmp") {
      return <SupplierSubscriptionSettingsmp {...props} />;
    }
    else if (props.component == "catalogmp") {
      return <Catalogmp {...props} />;
    }
    else if (props.component == "categoriesmp") {
      return <Categoriesmp {...props} />;
    }
    else if (props.component == "inventorymp") {
      return <Inventorymp {...props} />;
    }
    else if (props.component == "itemreviewsmp") {
      return <ItemReviewsmp {...props} />;
    }
    else if (props.component == "itemsizemp") {
      return <ItemSizemp {...props} />;
    }
    else if (props.component == "managefacetsmp") {
      return <ManageFacetsmp {...props} />;
    }
    else if (props.component == "pricesmp") {
      return <Pricesmp {...props} />;
    }
    else if (props.component == "itemoptionsmp") {
      return <ItemOptionsmp {...props} />;
    }
    else if (props.component == "itemstatussettingsmp") {
      return <ItemStatusSettingsmp {...props} />;
    }
    else if (props.component == "marketingmp") {
      return <Marketingmp {...props} />;
    }
    // else if (props.component == "blogsmp") {
    //   return <Blogsmp {...props} />;
    // }
    else if (props.component == "bundlesmp") {
      return <Bundlesmp {...props} />;
    }
    else if (props.component == "couponsmp") {
      return <Couponsmp {...props} />;
    }
    else if (props.component == "customerdiscountsmp") {
      return <CustomerDiscountsmp {...props} />;
    }
    else if (props.component == "customerretargetingmp") {
      return <CustomerRetargetingmp {...props} />;
    }
    else if (props.component == "customersegmentadsmp") {
      return <CustomerSegmentadsmp {...props} />;
    }
    else if (props.component == "customersegmentpricesmp") {
      return <CustomerSegmentPricesmp {...props} />;
    }
    else if (props.component == "customersegmentsmp") {
      return <CustomerSegmentsmp {...props} />;
    }
    else if (props.component == "giftcardsmp") {
      return <GiftCardsmp {...props} />;
    }
    else if (props.component == "giftcertificatesmp") {
      return <GiftCertificatesmp {...props} />;
    }
    else if (props.component == "marketingsegmentsmp") {
      return <MarketingSegmentsmp {...props} />;
    }
    else if (props.component == "salesareageolocationmp") {
      return <SalesAreaGeolocationmp {...props} />;
    }
    else if (props.component == "shippingexceptionsmp") {
      return <ShippingExceptionsmp {...props} />;
    }
    else if (props.component == "upsellcrosssellmp") {
      return <UpsellCrosssellmp {...props} />;
    }
    else if (props.component == "viralpromotionsmp") {
      return <ViralPromotionsmp {...props} />;
    }
    else if (props.component == "marketplacemp") {
      return <MarketPlacemp {...props} />;
    }
    else if (props.component == "approveproductsmp") {
      return <ApproveProductsmp {...props} />;
    }
    else if (props.component == "categoryprofitmarginmp") {
      return <CategoryProfitMarginmp {...props} />;
    }
    else if (props.component == "Commissionsmp") {
      return <Commissionsmp {...props} />;
    }
    else if (props.component == "marketplacecategoriesmp") {
      return <MarketPlaceCategoriesmp {...props} />;
    }
    else if (props.component == "marketplacepaymentsmp") {
      return <MarketplacePaymentsmp {...props} />;
    }
    else if (props.component == "marketplacecsuppliersmp") {
      return <MarketPlacecSuppliersmp {...props} />;
    }
    else if (props.component == "mastercatalogproductsmp") {
      return <MasterCatalogProductsmp {...props} />;
    }
    else if (props.component == "notificationsmp") {
      return <Notificationsmp {...props} />;
    }
    else if (props.component == "mediamp") {
      return <Mediamp {...props} />;
    }
    else if (props.component == "managemediamp") {
      return <ManageMediamp {...props} />;
    }
    else if (props.component == "ordersmp") {
      return <Ordersmp {...props} />;
    }
    // else if (props.component == "customermessagesmp") {
    //   return <CustomerMessagesmp {...props} />;
    // }
    // else if (props.component == "emailsettingsmp") {
    //   return <EmailSettingsmp {...props} />;
    // }
    // else if (props.component == "emailstatemp") {
    //   return <EmailStatemp {...props} />;
    // }
    // else if (props.component == "manageorderapprovalsgroupmp") {
    //   return <ManageOrderApprovalsGroupmp {...props} />;
    // }
    else if (props.component == "manageordersmp") {
      return <ManageOrdersmp {...props} />;
    }
    else if (props.component == "managerefundsmp") {
      return <ManageRefundsmp {...props} />;
    }
    // else if (props.component == "sellerratingsmp") {
    //   return <SellerRatingsmp {...props} />;
    // }
    // else if (props.component == "smssettingsmp") {
    //   return <SmsSettingsmp {...props} />;
    // }
    // else if (props.component == "smsstatemp") {
    //   return <SmsStatemp {...props} />;
    // }
    else if (props.component == "peoplemp") {
      return <Peoplemp {...props} />;
    }
    else if (props.component == "customerpropertiesmp") {
      return <CustomerPropertiesmp {...props} />;
    }
    else if (props.component == "customersmp") {
      return <Customersmp {...props} />;
    }
    // else if (props.component == "ssorulesmp") {
    //   return <SSOrulesmp {...props} />;
    // }
    else if (props.component == "settingsmp") {
      return <Settingsmp {...props} />;
    }
    else if (props.component == "basketpreferencesmp") {
      return <BasketPreferencesmp {...props} />;
    }
    else if (props.component == "imagescalingmp") {
      return <ImageScalingmp {...props} />;
    }
    else if (props.component == "itempropertiesmp") {
      return <ItemPropertiesmp {...props} />;
    }
    else if (props.component == "Orderpreferencesmp") {
      return <OrderPreferencesmp {...props} />;
    }
    else if (props.component == "paymentgatewaysmp") {
      return <PaymentGatewaysmp {...props} />;
    }
    else if (props.component == "retaillocationmp") {
      return <RetailLocationmp {...props} />;
    }
    else if (props.component == "shippingcountriesmp") {
      return <ShippingCountriesmp {...props} />;
    }
    // else if (props.component == "shippingratesmp") {
    //   return <ShippingRatesmp {...props} />;
    // }
    // else if (props.component == "sitemapsmp") {
    //   return <SiteMapsmp {...props} />;
    // }
     else if (props.component == "storecurrenciesmp") {
      return <StoreCurrenciesmp {...props} />;
    }
     else if (props.component == "storepreferencesmp") {
      return <StorePreferencesmp {...props} />;
     }
    // else if (props.component == "storepropertiesmp") {
    //   return <StorePropertiesmp {...props} />;
    // }
     else if (props.component == "taxratesmp") {
       return <TaxRatesmp {...props} />;
     }
    else if (props.component == "templatesmp") {
      return <Templatesmp {...props} />;
    }
    else if (props.component == "catalogpersonalizationmp") {
      return <CatalogPersonalizationmp {...props} />;
    }
    else if (props.component == "resetCDTOcachemp") {
      return <ResetCDTOcachemp {...props} />;
    }
    // else if (props.component == "templateskinsmp") {
    //   return <TemplateSkinsmp {...props} />;
    // }
    else if (props.component == "managetemplatesmp") {
      return <ManageTemplatesmp {...props} />;
    }
    else if (props.component == "catalogsp") {
      return <Catalogsp {...props} />;
    }
    else if (props.component == "productsp") {
      return <Productssp {...props} />;
    }
    else if (props.component == "inventorysp") {
      return <Inventorysp {...props} />;
    }
    else if (props.component == "itempropertiessp") {
      return <ItemPropertiessp {...props} />;
    }
    else if (props.component == "dashboardsp") {
      return <Dashboardsp {...props} />;
    }
    else if (props.component == "marketplacesp") {
      return <Marketplacesp {...props} />;
    }
    else if (props.component == "notificationssp") {
      return <Notificationssp {...props} />;
    }
    else if (props.component == "marketplacepaymentssp") {
      return <MarketplacePaymentssp {...props} />;
    }
    else if (props.component == "approveproductssp") {
      return <ApproveProductssp {...props} />;
    }
    else if (props.component == "mediasp") {
      return <Mediasp {...props} />;
    }
    else if (props.component == "managemediasp") {
      return <Managemediasp {...props} />;
    }
    else if (props.component == "orderssp") {
      return <Orderssp {...props} />;
    }
    else if (props.component == "manageorderssp") {
      return <Manageorderssp {...props} />;
    }
    else if (props.component == "managerefundssp") {
      return <Managerefundssp {...props} />;
    }
    else if (props.component == "reportssp") {
      return <Reportssp {...props} />;
    }
    else if (props.component == "customermessagessp") {
      return <Customermessagessp {...props} />;
    }
    else if (props.component == "advancedmcw") {
      return <Advancedmcw {...props} />;
    }
    else if (props.component == "changepasswordmcw") {
      return <Changepasswordmcw {...props} />;
    }
    else if (props.component == "mediamcw") {
      return <Mediamcw {...props} />;
    }
    else if (props.component == "managemediamcw") {
      return <Managemediamcw {...props} />;
    }
    else if (props.component == "catalogmcw") {
      return <Catalogmcw {...props} />;
    }
    else if (props.component == "categoriesmcw") {
      return <Categoriesmcw {...props} />;
    }
    else if (props.component == "inventorymcw") {
      return <Inventorymcw {...props} />;
    }
    else if (props.component == "itemreviewsmcw") {
      return <Itemreviewsmcw {...props} />;
    }
    else if (props.component == "itemsizemcw") {
      return <Itemsizemcw {...props} />;
    }
    else if (props.component == "pricesmcw") {
      return <Pricesmcw {...props} />;
    }
    else if (props.component == "variationsmcw") {
      return <Variationsmcw {...props} />;
    }
    else if (props.component == "itemstatussettingsmcw") {
      return <Itemstatussettingsmcw {...props} />;
    }
    else if (props.component == "marketplacemcw") {
      return <Marketplacemcw {...props} />;
    }
    else if (props.component == "approveproductsmcw") {
      return <Approveproductsmcw {...props} />;
    }
    else if (props.component == "marketplacecsuppliersmcw") {
      return <Marketplacecsuppliersmcw {...props} />;
    }
    else if (props.component == "notificationsmcw") {
      return <Notificationsmcw {...props} />;
    }
    else if (props.component == "settingsmcw") {
      return <Settingsmcw {...props} />;
    }
    else if (props.component == "itempropertiesmcw") {
      return <Itempropertiesmcw {...props} />;
    }
    else if (props.component == "shippingcountriesmcw") {
      return <Shippingcountriesmcw {...props} />;
    }
    else if (props.component == "storecurrenciesmcw") {
      return <Storecurrenciesmcw {...props} />;
    }
    else if (props.component == "storepreferencesmcw") {
      return <Storepreferencesmcw {...props} />;
    }
    else if (props.component == "storepropertiesmcw") {
      return <Storepropertiesmcw {...props} />;
    }
    else if (props.component == "ordersmcw") {
      return <Ordersmcw {...props} />;
    }
    else if (props.component == "customermessagesmcw") {
      return <Customermessagesmcw {...props} />;
    }
    else {
      return <NotFound {...props} />;
    }
  };

  if(loading){
    return(
      <>
        <div className="row mb0">
          <div className={classes.root}>
            <AppBar position="static">
              <div className="head-container">
                <Toolbar>
                  <Link to="/">
                    <Typography variant="h6" className={classes.title} noWrap>
                      <img src={AvettiLogo} className="AvettiLogo" />
                    </Typography>
                  </Link>
                  <div className={classes.search}>
                    <MenuCore />
                  </div>
                  <div className={classes.grow} />
                  {/* <Button color="inherit"><Link  style={{color:"#fff"}} to="/login">Login</Link></Button> */}
                  {/* <Profie/>
                  <IconButton aria-label="search" color="inherit">
                    <SearchIcon />
                  </IconButton>
                  <IconButton aria-label="display more actions" edge="end" color="inherit">
                    <MoreIcon />
                  </IconButton> */}
                </Toolbar>
              </div>
            </AppBar>
          </div>
        </div>
        <Loading />
      </>
    )
  }

  else if (props.component == "home") {
    return (
      <>
        <div className="row mb0">
          <div className={classes.root}>
            <AppBar position="static">
              <div className="head-container">
                <Toolbar>
                  <Link to="/">
                    <Typography variant="h6" className={classes.title} noWrap>
                      <img src={AvettiLogo} className="AvettiLogo" />
                    </Typography>
                  </Link>
                  <div className={classes.search}>
                    <MenuCore />
                  </div>
                  <div className={classes.grow} />
                  {/* <Button color="inherit"><Link  style={{color:"#fff"}} to="/login">Login</Link></Button> */}
                  {/* <Profie/>
                  <IconButton aria-label="search" color="inherit">
                    <SearchIcon />
                  </IconButton>
                  <IconButton aria-label="display more actions" edge="end" color="inherit">
                    <MoreIcon />
                  </IconButton> */}
                </Toolbar>
              </div>
            </AppBar>
          </div>
        </div>
        <Main />
      </>
    );
  }

  else if (props.component == "marketplacepage") {
    return (
      <>
        <div className="row mb0">
          <div className={classes.root}>
            <AppBar position="static">
              <div className="head-container">
                <Toolbar>
                  <Link to="/">
                    <Typography variant="h6" className={classes.title} noWrap>
                      <img src={AvettiLogo} className="AvettiLogo" />
                    </Typography>
                  </Link>
                  <div className={classes.search}>
                    <MenuCore />
                  </div>
                  <div className={classes.grow} />
                  {/* <Button color="inherit"><Link  style={{color:"#fff"}} to="/login">Login</Link></Button> */}
                  {/* <Profie/>
                  <IconButton aria-label="search" color="inherit">
                    <SearchIcon />
                  </IconButton>
                  <IconButton aria-label="display more actions" edge="end" color="inherit">
                    <MoreIcon />
                  </IconButton> */}
                </Toolbar>
              </div>
            </AppBar>
          </div>
        </div>
        <MarketPlacePage />
      </>
    );
  }

  else {
    return (
      <>
        <div className="row mb0">
          <div className={classes.root}>
            <AppBar position="fixed">
              <div className="head-container">
                <Toolbar>
                  <Link to="/">
                    <Typography variant="h6" className={classes.title} noWrap>
                      <img src={AvettiLogo} className="AvettiLogo" />
                    </Typography>
                  </Link>
                  <div className={classes.search}>
                    <MenuCore />
                  </div>
                  <div className={classes.grow} />
                  {/* <Button color="inherit"><Link style={{color:"#fff"}} to="/login">Login</Link></Button> */}
                  {/* <Profie/>
                  <IconButton aria-label="search" color="inherit">
                    <SearchIcon />
                  </IconButton>

                  <IconButton aria-label="display more actions" edge="end" color="inherit">
                    <MoreIcon />
                  </IconButton> */}
                </Toolbar>
              </div>
            </AppBar>
          </div>
        </div>
        <div className="head-container">
          {
            handleWhatComponentToShowHere()
          }
        </div>
        {
          handleWhatComponentToShowHere() ? <Footer /> : <Loading/>
        }

      </>
    );
  }
}

Menus.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(menuStyle)(Menus);
